import React, { Component, useEffect } from "react";
import ReactAudioPlayer from "react-audio-player";
import ReactPlayer from "react-player";
import { useParams, useNavigate } from "react-router-dom";
import { executeGet, goBack } from "../functions/Kubuku";
import { BASE_URL, RETURN_AUDIO_PLAYER } from "../api";
import { disableSplashScreen } from "../api/enkripsi";
import SkeletonBookDetail from "../components/SkeletonBookDetail";
function WithNavigate(props) {
  let navigate = useNavigate();
  return <AudioPlayer {...props} navigate={navigate} params={useParams()} />;
}

class AudioPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      showMain: false,
      params: this.props.params,
      dataBuku: [],
      alias: window.localStorage.getItem("alias"),
      lokasi: "",
      lat: "-7.557130246009252",
      long: "110.79448368501073",
      alt: "1",
      flagData: false,
      audioList: [],
      hal: 1,
      color: window.localStorage.getItem("color"),
      darkcolor: "bg-orang-dark",
      textcolor: "text-orange",
      firstRun: true,
      uuid: "",
      idTrxAudioPlayer: 0,
    };
  }

  componentDidMount = async () => {
    if (this.state.firstRun) {
      this.setState({
        alias: window.localStorage.getItem("alias"),
        uuid: localStorage.getItem("uuid"),
      });
      this.getTheme();
      this.getLocation();
      disableSplashScreen();
    }
  };

  getLocation = () => {
    if (window.localStorage.getItem("sn") != null) {
      this.loadData(
        window.localStorage.getItem("lat"),
        window.localStorage.getItem("long"),
        window.localStorage.getItem("alt")
      );
    } else {
      navigator.geolocation.getCurrentPosition((position) => {
        let long = Number(position.coords.longitude);
        let lat = Number(position.coords.latitude);
        let alt = position.coords.altitude;
        this.setState({
          lat: lat,
          long: long,
          alt: alt,
        });
        this.loadData(lat, long, alt);
      });
    }
  };

  loadData = async (lat, long, alt) => {
    try {
      var json = await executeGet(
        BASE_URL +
          "detailContent/" +
          this.props.params.id +
          "/" +
          this.state.alias +
          "?uuid=" +
          localStorage.getItem("uuid")
      );
      if (json.code == "200") {
        this.setState({
          dataBuku: json.data,
          audioList: json.multimedia,
          flagData: true,
          isLoading: false,
          idTrxAudioPlayer: json.id_trx_baca,
        });
      } else {
        this.setState({
          isLoading: false,
          flagData: false,
        });
      }
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  returnAudioPlayer = async () => {
    try {
      this.setState({
        isLoading: true,
      });
      const response = await executeGet(
        RETURN_AUDIO_PLAYER +
          this.state.idTrxAudioPlayer +
          "/" +
          localStorage.getItem("alias")
      );
      if (response.code == 200) {
        this.setState({
          isLoading: true,
        });
        goBack();
      }
    } catch (error) {
      console.error(error);
    }
  };

  getTheme = async () => {
    try {
      if (window.localStorage.getItem("themes") != null) {
        const ljson = window.localStorage.getItem("themes");
        const json = JSON.parse(ljson);
        if (json.code == 200) {
          if (json.warna != "") {
            this.setState({
              color: json.warna,
            });
          }
          if (json.dark != "") {
            this.setState({
              darkcolor: json.dark,
            });
          }
          if (json.text != "") {
            this.setState({
              textcolor: json.text,
            });
          }
        }
      }
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };
  render() {
    return (
      <div style={{ backgroundColor: "#ecf0f1" }}>
        <nav className="fixed top-0 w-full z-10 shadow-md">
          <div
            onClick={() => this.returnAudioPlayer()}
            className={
              "flex p-4 " +
              this.state.color +
              " text-lg text-white font-semibold items-center"
            }
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mr-8"
            >
              <path
                d="M15 6L9 12L15 18"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="line-clamp-1 ">Player</span>
          </div>
        </nav>
        {this.state.isLoading ? (
          <SkeletonBookDetail />
        ) : (
          <>
            {this.state.audioList.length > 0 ? (
              <>
                <div
                  style={{
                    flexGrow: "1",
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#ecf0f1",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: 320,
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#184999",
                      position: "sticky",
                      top: 0,
                      left: 0,
                      right: 0,
                    }}
                  >
                    <div
                      className={
                        "relative mt-[56px] px-4 py-6 h-8  rounded-bl-3xl"
                      }
                    >
                      <img
                        src={this.state.dataBuku.cover}
                        alt="cover buku"
                        className="absolute w-32 h-32 left-[35%] sm:left-[45%] md:left-[40%] rounded-full shadow-md"
                      />

                      <h3 className="text-center mt-40 text-xl font-bold text-slate-200 line-clamp-2">
                        {this.state.dataBuku.judul}
                      </h3>
                      <h4 className="text-sm text-center text-slate-400 line-clamp-1">
                        {this.state.dataBuku.penulis}
                      </h4>
                    </div>
                  </div>
                  <div className="z-0 relative mt-[32px] mb-[70px] sm:mb-0 sm:mt-[30px] md:mb-[28px] bg-white before:absolute before:top-[-25px] before:left-0 before:w-full before:h-[25px] before:bg-white before:rounded-t-2xl after:absolute after:w-20 after:h-1 after:top-[-14px] after:left-[38%] after:sm:left-[44%] after:bg-gray-200 after:rounded-full">
                    <div
                      style={{
                        marginLeft: "10px",
                        marginRight: "10px",
                        mt: 4,
                        mb: 4,
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "white",
                      }}
                    >
                      {this.state.audioList.map((item, index) => (
                        <div
                          key={"plyr_" + index}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            mt: 2,
                          }}
                        >
                          <div>{item.judul}</div>
                          {item.file.indexOf(".mp4") > 0 ? (
                            <ReactPlayer
                              controls={true}
                              width={"95vw"}
                              height={"30vh"}
                              config={{
                                file: {
                                  attributes: { controlsList: "nodownload" },
                                },
                              }}
                              url={item.file}
                            />
                          ) : (
                            <ReactAudioPlayer
                              src={item.file}
                              style={{
                                width: "95vw",
                                borderRadius: "5px",
                                backgroundColor: "#f1f3f4",
                              }}
                              controls
                              controlsList={"nodownload"}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="mt-16 mb-4">
                <svg
                  width="204"
                  height="168"
                  viewBox="0 0 204 168"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mx-auto"
                >
                  <path
                    d="M7.51514 77.2217V78.9444"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M3.64648 78.1548L5.05412 79.6039"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M2 82.0122H3.99038"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M3.48535 85.9381L4.89299 84.4891"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M7.51514 86.4091V84.6865"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10.3862 85.2607L9.23779 84.1123"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M12.6831 82.3896H10.9604"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M11.5347 78.3702L10.3862 79.5186"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M99.9629 2V3.14842"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M96.5181 5.44528H97.6665"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M99.9629 8.89055V7.74213"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M102.834 5.44528H101.686"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M33.3545 50.2338V51.9564"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M28.1865 55.4017H29.9092"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M33.3545 59.9954V58.2728"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M37.9482 55.4017H36.2256"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    d="M156.956 112.845C158.329 112.845 159.442 113.959 159.442 115.331C159.442 116.704 158.329 117.817 156.956 117.817C155.584 117.817 154.471 116.704 154.471 115.331"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M168.33 90.2928C169.806 89.8325 172.068 88.0279 172.591 86.0862C173.066 87.8026 175.056 89.8325 176.852 89.9861C174.831 90.7019 172.898 92.8284 172.591 94.4989C172.383 92.7962 169.709 90.541 168.33 90.2928Z"
                    fill="#EBECEE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.8594 112.08C17.5974 111.849 18.7279 110.947 18.9897 109.977C19.2271 110.834 20.222 111.849 21.12 111.927C20.1094 112.284 19.1432 113.347 18.9897 114.183C18.8853 113.331 17.5487 112.203 16.8594 112.08Z"
                    fill="#EBECEE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.5557 32.2019C30.5557 33.2668 29.6928 34.1294 28.6287 34.1294C27.564 34.1294 26.7017 33.2668 26.7017 32.2019C26.7017 31.1375 27.564 30.2744 28.6287 30.2744C29.6928 30.2744 30.5557 31.1375 30.5557 32.2019Z"
                    fill="#D1D8DF"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M159.233 37.3776C159.233 39.1569 157.791 40.5992 156.012 40.5992C154.233 40.5992 152.791 39.1569 152.791 37.3776C152.791 35.5983 154.233 34.1559 156.012 34.1559C157.791 34.1559 159.233 35.5983 159.233 37.3776Z"
                    fill="#EBECEE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M203.847 28.649C203.847 30.0606 202.703 31.2045 201.293 31.2045C199.881 31.2045 198.738 30.0606 198.738 28.649C198.738 27.2373 199.881 26.0934 201.293 26.0934C202.703 26.0934 203.847 27.2373 203.847 28.649Z"
                    fill="#EBECEE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M66.5694 148.004C66.5694 148.893 65.8484 149.615 64.9588 149.615C64.0696 149.615 63.3486 148.893 63.3486 148.004C63.3486 147.114 64.0696 146.392 64.9588 146.392C65.8484 146.392 66.5694 147.114 66.5694 148.004Z"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M65.6114 19.8188C65.6114 20.8837 64.7485 21.7463 63.6843 21.7463C62.6202 21.7463 61.7573 20.8837 61.7573 19.8188C61.7573 18.7543 62.6202 17.8913 63.6843 17.8913C64.7485 17.8913 65.6114 18.7543 65.6114 19.8188Z"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M114.766 165.843C113.534 166.312 112.156 165.693 111.688 164.462C111.219 163.23 111.837 161.851 113.069 161.383C114.3 160.915 115.678 161.533 116.147 162.765C116.616 163.996 115.997 165.375 114.766 165.843Z"
                    stroke="#D2D8DF"
                    strokeWidth="2.921"
                    stroke-linecap="round"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M114.032 120.288H66.9442C63.6299 120.288 60.917 117.567 60.917 114.241V47.0914C60.917 43.766 63.6299 41.0464 66.9442 41.0464H114.032C117.348 41.0464 120.061 43.766 120.061 47.0914V114.241C120.061 117.567 117.348 120.288 114.032 120.288Z"
                    fill="#E0E2EE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M110.013 123.159H62.9247C59.6104 123.159 56.8975 120.438 56.8975 117.112V49.9625C56.8975 46.637 59.6104 43.9174 62.9247 43.9174H110.013C113.328 43.9174 116.041 46.637 116.041 49.9625V117.112C116.041 120.438 113.328 123.159 110.013 123.159Z"
                    fill="#E8EBF2"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M106.103 125.425H58.9176C55.5965 125.425 52.8779 122.716 52.8779 119.404V52.5321C52.8779 49.2204 55.5965 46.5121 58.9176 46.5121H106.103C109.425 46.5121 112.144 49.2204 112.144 52.5321V119.404C112.144 122.716 109.425 125.425 106.103 125.425Z"
                    fill="#D8DBEA"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M106.103 125.425H58.9176C55.5965 125.425 52.8779 122.716 52.8779 119.404V52.5321C52.8779 49.2204 55.5965 46.5121 58.9176 46.5121H106.103C109.425 46.5121 112.144 49.2204 112.144 52.5321V119.404C112.144 122.716 109.425 125.425 106.103 125.425Z"
                    fill="#F1F2F7"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M99.3018 97.8934H64.4497C63.4544 97.8934 62.6396 97.1183 62.6396 96.1714C62.6396 95.2232 63.4544 94.4481 64.4497 94.4481H99.3018C100.297 94.4481 101.112 95.2232 101.112 96.1714C101.112 97.1183 100.297 97.8934 99.3018 97.8934Z"
                    fill="#E0E2EE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M82.6419 108.229H64.4574C63.4578 108.229 62.6396 107.454 62.6396 106.507C62.6396 105.559 63.4578 104.784 64.4574 104.784H82.6419C83.6415 104.784 84.4597 105.559 84.4597 106.507C84.4597 107.454 83.6415 108.229 82.6419 108.229Z"
                    fill="#E0E2EE"
                  />
                  <rect
                    x="62.8667"
                    y="55.4017"
                    width="38.4722"
                    height="31.0074"
                    rx="9"
                    fill="#E7E9F5"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M119.346 94.8712C112.377 101.839 101.588 102.625 93.7551 97.2454C92.754 96.5456 91.8013 95.7595 90.9128 94.8712C90.4554 94.4153 90.0243 93.9448 89.6181 93.4495C88.8056 92.4604 88.0939 91.4055 87.5108 90.3155C86.4835 88.4746 85.785 86.5211 85.4036 84.5019C84.1732 78.1697 86.013 71.3538 90.9128 66.4563C95.8243 61.5441 102.641 59.7163 108.975 60.9349C110.993 61.3279 112.948 62.0263 114.789 63.0417C115.881 63.6378 116.921 64.3494 117.912 65.1617C118.406 65.5665 118.877 65.9989 119.333 66.4563C120.222 67.3446 121.02 68.2957 121.707 69.298C127.089 77.1279 126.302 87.9165 119.346 94.8712Z"
                    fill="white"
                    fill-opacity="0.1"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M117.396 93.4988C110.145 100.751 98.3954 100.749 91.1437 93.4988C83.9015 86.2566 83.9015 74.5055 91.1532 67.2551C98.3954 60.0129 110.145 60.0129 117.387 67.2551C124.638 74.5055 124.638 86.2566 117.396 93.4988ZM121.116 63.5299C111.81 54.2235 96.7292 54.2235 87.4228 63.5299C78.1177 72.835 78.1096 87.9253 87.4147 97.2318C95.8847 105.699 109.16 106.463 118.498 99.5105C119.41 98.8305 120.288 98.0682 121.126 97.2318C121.962 96.3939 122.725 95.5156 123.403 94.6036C130.355 85.2648 129.585 71.9986 121.116 63.5299Z"
                    fill="#E0E2EE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M157.742 132.313L157.351 132.703C154.766 135.289 150.533 135.289 147.947 132.703L124.08 108.836L133.875 99.0418L157.742 122.909C160.328 125.495 160.328 129.726 157.742 132.313Z"
                    fill="url(#paint0_linear_107_235)"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M123.918 93.8739L130.971 100.927L125.964 105.932L118.912 98.8795C119.843 98.1857 120.738 97.4078 121.594 96.5543C122.447 95.7007 123.225 94.8045 123.918 93.8739Z"
                    fill="#E0E2EE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M157.384 122.615L147.652 132.346L145.9 130.593L155.631 120.862L157.384 122.615Z"
                    fill="#EF545F"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M134.416 99.3788L124.417 109.378L122.932 107.892L132.93 97.8934L134.416 99.3788Z"
                    fill="url(#paint1_linear_107_235)"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M112.596 64.7606L88.075 89.2802C87.1516 87.6252 86.5237 85.869 86.1821 84.0537L107.369 62.8665C109.183 63.2211 110.941 63.8477 112.596 64.7606Z"
                    fill="white"
                    fill-opacity="0.5"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M120.635 70.5887L94.1252 95.5965C93.1758 94.9715 92.2722 94.2681 91.4296 93.4732C90.9958 93.064 90.5856 92.6443 90.2017 92.201L117.034 66.8859C117.504 67.2494 117.95 67.6364 118.383 68.0456C119.225 68.8406 119.984 69.6917 120.635 70.5887Z"
                    fill="white"
                    fill-opacity="0.5"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_107_235"
                      x1="141.881"
                      y1="81.2412"
                      x2="106.28"
                      y2="116.842"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF8960" />
                      <stop offset="1" stopColor="#FF62A5" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_107_235"
                      x1="128.674"
                      y1="92.1513"
                      x2="117.19"
                      y2="103.635"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF404E" />
                      <stop offset="1" stopColor="#FF62A5" />
                    </linearGradient>
                  </defs>
                </svg>
                <div className="px-8 mt-6 mb-6 text-center">
                  <h3 className="text-black text-lg font-semibold">
                    Buku Tidak tersedia
                  </h3>
                  <p className="mt-4 text-sm text-gray-light">
                    Buku yang anda cari tidak tersedia, silahkan cari buku lain
                  </p>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}
export default WithNavigate;
